import React, { useState } from "react";
import "./Contact.css";

const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    pickup: "",
    drop: "",
    date: "",
    message: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleWhatsAppSend = (e) => {
    e.preventDefault();
    const { name, phone, pickup, drop, date, message } = formData;

    // WhatsApp message format
    const text = `🚕 *New Taxi Booking Request* 🚕
Name: ${name}
Phone: ${phone}
Pickup: ${pickup}
Drop: ${drop}
Date: ${date}
Message: ${message}`;

    // Replace with your WhatsApp number (no + or spaces)
    const phoneNumber = "919585306000";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(text)}`;

    // Open WhatsApp chat
    window.open(url, "_blank");
  };

  return (

    <section className="contact-section" id="contact">
      <div className="contact-container">

        {/* Left side - Book Now Form */}
        <div className="contact-left">
          <h2 className="head">Book Your Ride</h2>
          <p>Fill in your travel details and we’ll get in touch to confirm your booking.</p>

          <form className="contact-form" onSubmit={handleWhatsAppSend}>
            <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} required />
            <input type="text" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} required />
            <input type="text" name="pickup" placeholder="Pickup Location" value={formData.pickup} onChange={handleChange} required />
            <input type="text" name="drop" placeholder="Drop Location" value={formData.drop} onChange={handleChange} required />
            <input type="date" name="date" value={formData.date} onChange={handleChange} required />
            <textarea name="message" placeholder="Additional Message" rows="4" value={formData.message} onChange={handleChange}></textarea>
            <button type="submit">Book Now</button>
          </form>
        </div>

        {/* Right side - Contact Information */}
        <div className="contact-right">
          <h3 className="head">Contact Information</h3>
          <ul>
            <li><strong>Phone:</strong> +91 95853 06000</li>
            <li><strong>WhatsApp:</strong> +91 95853 06000</li>
            <li><strong>Email:</strong> info@uzhavantaxi.com</li>
            <li><strong>Address:</strong> 1st Floor, Cavery illam, 105, Thennamara Salai, opp. CallTax Road, Mayiladuthurai</li>
          </ul>

          <div className="contact-map">
            <iframe
              title="Uzhavan Taxi Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3915.0784559755234!2d79.64883487370076!3d11.107530653001882!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a5527bf3eec9eaf%3A0x7bdcfd1372cb65c!2sUzhavan%20Taxi!5e0!3m2!1sen!2sin!4v1761735482512!5m2!1sen!2sin"
              width="100%"
              height="220"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>

      </div>
    </section>
    
  );
};

export default Contact;
